import {
  getOneOrder,
  updateOrder,
  addConfirmOrder,
  getConfirmOrderList,
  getPlantsDropdown,
  getPaymentTermsDropdown,
  updateConfirmOrder,
  deleteConfirmOrder,
  getTrackingDetailsList,
  addOrUpdateTrackingDetails,
} from "http/order/order"
import React, { useContext, useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { startCase } from "lodash"
import Select from "react-select"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap"
import { formatDateTime, formatNumberWithCommas } from "common/utility"
import ToastDialog from "components/Common/ToastDialog"
import DeleteModal from "components/Common/DeleteModal"
import CommonDialog from "components/Common/CommonDialog"
import { SystemConfigurationContext } from "context/systemConfigContext"
import { Tooltip } from "react-tooltip"
import AdminShipmentDetail from "components/AdminShipmentDetail"
import FullPageLoader from "components/Common/FullPageLoader"
import { getAllRegions } from "helpers/UAM/region.helper"

const ViewOrder = () => {
  document.title = "View Order | DMS"
  const navigate = useNavigate()
  const [order, setOrder] = useState(null)
  const [status, setStatus] = useState({})
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const [currOrderStatus, setCurrOrderStatus] = useState(null)
  const [confirmOrders, setConfirmOrders] = useState([])
  const { id } = useParams()
  const [selectedProducts, setSelectedProducts] = useState([])
  const [selectedPlant, setSelectedPlant] = useState(null)
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null)
  const [selectedOrderReason, setSelectedOrderReason] = useState(null)
  const [plantOptions, setPlantOptions] = useState([])
  const [paymentTermOptions, setPaymentTermOptions] = useState([])
  const [orderReasonOptions, setOrderReasonOptions] = useState([])
  const [plannedDeliveryDate, setPlannedDeliveryDate] = useState(null)
  const [allQty, setAllQty] = useState(false)
  const [hasOrderStatusUpdated, setHasOrderStatusUpdated] = useState(false)
  const [deleteModal, setDeleteModal] = useState({ open: false, id: null })
  const [isCreatingOrder, setIsCreatingOrder] = useState(false)
  const [isChangeStatus, setIsChangeStatus] = useState(false)
  const user = JSON.parse(localStorage.getItem("user"))
  const [trackingUrl, setTrackingUrl] = useState({})
  const [showCommonDialog, setShowCommonDialog] = useState({
    isShow: false,
    message: "",
    data: null,
  })
  const { inputMax } = useContext(SystemConfigurationContext)
  const [productOpen, setProductOpen] = useState({})
  const [showDropdown, setShowDropdown] = useState({})
  const [open, setOpen] = useState("1")
  const [hasError, setHasError] = useState([])
  const [hasConfirmError, setHasConfirmError] = useState([])
  const [showCheckboxes, setShowCheckboxes] = useState(true)

  const toggle = id => {
    if (open === id) {
      setOpen()
    } else {
      setOpen(id)
    }
  }

  const toggleProduct = (index, accordionId) => {
    setProductOpen(prevOpen => ({
      ...prevOpen,
      [index]: prevOpen[index] === accordionId ? undefined : accordionId,
    }))
  }
  useEffect(() => {
    fetchOrder()
    fetchConfirmOrder()
    fetchPaymentTerms()
    fetchPlants()
    fetchTrackingDetails()
    fetchOrderReason()
  }, [id])

  const fetchOrder = () => {
    getOneOrder({ id: id })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          const orderData = responseFromAPI.data
          const orderWithSelectedQty = {
            ...orderData,
            products: orderData?.products?.map(product => ({
              ...product,
              selectedQty: product?.remainingQuantity || 0,
            })),
          }
          setCurrOrderStatus(orderWithSelectedQty?.orderStatus)
          setOrder(orderWithSelectedQty)
          const allProductsHaveZeroQuantity = orderData?.products?.every(
            product => product?.quantity === 0
          )
          if (allProductsHaveZeroQuantity) {
            setAllQty(true)
          } else {
            setAllQty(false)
          }
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  const fetchConfirmOrder = () => {
    getConfirmOrderList({ requestOrderId: id, isSearch: false })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          const orderData = responseFromAPI?.data?.data

          setConfirmOrders(orderData)
        } else {
          setConfirmOrders([])
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  const fetchPlants = async () => {
    try {
      let res = await getPlantsDropdown()
      if (res.status) {
        setPlantOptions(
          res?.data?.data?.map(i => ({
            label: `${i.description} (${i.plantId})`,
            value: i.plantId,
          }))
        )
      }
    } catch (error) {
      console.error(error)
    }
  }

  const fetchPaymentTerms = async () => {
    try {
      let res = await getPaymentTermsDropdown()
      if (res.status) {
        setPaymentTermOptions(
          res?.data?.data?.map(i => ({
            label: `${i.description} (${i.paymentId})`,
            value: i.paymentId,
          }))
        )
      }
    } catch (error) {
      console.error(error)
    }
  }

  const fetchTrackingDetails = async () => {
    try {
      let res = await getTrackingDetailsList()
      if (res.status) {
        const trackingDetailsData = res.data
        const initialTrackingUrls = trackingDetailsData?.reduce((acc, data) => {
          acc[data.orderId] = data.trackingDetails
          return acc
        }, {})
        setTrackingUrl(initialTrackingUrls)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const updateOrderStatus = async order => {
    try {
      let newStatus = null
      if (confirmOrders && confirmOrders?.length > 0) {
        const allProductsQuantityZero = order?.products?.every(
          product => product?.remainingQuantity === 0
        )
        setShowCheckboxes(!allProductsQuantityZero)
        newStatus = allProductsQuantityZero ? "processed" : "processing"
      } else {
        if (
          order.orderStatus !== "pending" &&
          order.orderStatus !== "cancelled" &&
          order.orderStatus !== "rejected"
        )
          newStatus = "pending"
      }
      if (newStatus) {
        try {
          await updateOrder({
            orderStatus: newStatus,
            remarks: null,
            id: order.id,
          })
        } catch (error) {
          throw new Error("Failed to update order")
        }
        setHasOrderStatusUpdated(true)
        fetchOrder()
      }
    } catch (error) {
      setToastInfo({
        message:
          error.message ||
          "Something went wrong while updating the order status",
        showToast: true,
        role: "error",
      })
    }
  }

  useEffect(() => {
    if (confirmOrders.length > 0 && !hasOrderStatusUpdated) {
      updateOrderStatus(order)
    }
  }, [order, confirmOrders])

  const handleCancel = () => {
    navigate(-1)
  }

  const handleUpdateStatus = orderId => {
    setIsChangeStatus(true)
    const order = confirmOrders.find(order => order.id === orderId)
    if (order && order.orderStatus === "shipped") {
      setToastInfo({
        message: "Order already shipped",
        showToast: true,
        role: "error",
      })
      setIsChangeStatus(false)
    } else {
      updateConfirmOrder({ orderStatus: "shipped", remarks: null, id: orderId })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            setToastInfo({
              message: responseFromAPI.message,
              showToast: true,
              role: "success",
            })
            setIsChangeStatus(false)
            fetchConfirmOrder()
            setShowDropdown(prevState => ({ ...prevState, [orderId]: false }))
          }
        })
        .catch(error => {
          setIsChangeStatus(false)
          console.error(error)
        })
    }
  }

  const handleCheckboxChange = productId => {
    const updatedSelectedProducts = [...selectedProducts]
    const productIndex = updatedSelectedProducts.indexOf(productId)

    if (productIndex !== -1) {
      updatedSelectedProducts.splice(productIndex, 1)
    } else {
      const product = order?.products?.find(p => p.id === productId)
      if (product && product.remainingQuantity > 0) {
        updatedSelectedProducts.push(productId)
      }
    }

    setSelectedProducts(updatedSelectedProducts)
  }

  const handleSelectAll = () => {
    const allProductIds = order?.products
      ?.filter(product => product.remainingQuantity !== 0)
      .map(product => product.id)

    if (selectedProducts.length === allProductIds.length) {
      setSelectedProducts([])
    } else {
      setSelectedProducts(allProductIds)
    }
  }

  const validateSelectedProduct = (selectedProduct, productsArray) => {
    const selectedQty = selectedProduct?.selectedQty || 0

    if (selectedQty < 1) {
      return {
        isValid: false,
        errorMessage: `Quantity must be greater than 0.`,
      }
    } else if (selectedQty > selectedProduct.quantity) {
      return {
        isValid: false,
        errorMessage: `Quantity cannot exceed the requested quantity.`,
      }
    } else {
      productsArray.push({
        productId: selectedProduct.productId,
        quantity: selectedQty,
        price: selectedProduct.price,
        productCode: selectedProduct?.product?.productCode,
      })
      return { isValid: true, errorMessage: "" }
    }
  }

  const handleCreateOrder = async () => {
    setIsCreatingOrder(true)

    if (selectedProducts.length === 0) {
      setToastInfo({
        message: "Please select at least one product.",
        showToast: true,
        role: "error",
      })
      setIsCreatingOrder(false)
      return
    }

    let isValid = true
    let errorMessage = ""
    const productsArray = []

    for (const productId of selectedProducts) {
      const selectedProduct = order?.products?.find(
        product => product.id === productId && product.quantity > 0
      )

      if (selectedProduct) {
        if (selectedProduct.selectedQty > selectedProduct.remainingQuantity) {
          setToastInfo({
            message: `Quantity cannot exceed remaining quantity.`,
            showToast: true,
            role: "error",
          })
          setIsCreatingOrder(false)
          return
        }

        const validationResult = validateSelectedProduct(
          selectedProduct,
          productsArray
        )

        if (!validationResult.isValid) {
          isValid = false
          errorMessage = validationResult.errorMessage
          break
        }
      }
    }

    if (!isValid) {
      setToastInfo({
        message: errorMessage,
        showToast: true,
        role: "error",
      })
      setIsCreatingOrder(false)
      return
    }

    try {
      const orderData = {
        requestOrderId: order.id,
        dealerId: order.dealerId,
        dealerUserId: order.dealerUserId,
        address: order.address,
        products: productsArray,
        orderStatus: "accepted",
        plantId: selectedPlant.value,
        paymentTerms: selectedPaymentTerm.value,
        plantDescription: selectedPlant.label,
        paymentTermsDescription: selectedPaymentTerm.label,
        plannedDeliveryDate: plannedDeliveryDate,
        requestOrderCode: order.orderCode,
        poNumber: order.poNumber,
        poDate: order.poDate,
        orderReason: selectedOrderReason.value,
        shipToParty: order.shipToParty
      }

      const res = await addConfirmOrder(orderData)

      if (res.status) {
        setToastInfo({
          message: "Order created successfully.",
          showToast: true,
          role: "success",
        })

        const updatedProducts = order?.products?.map(product => ({
          ...product,
          selectedQty: 0,
        }))

        setOrder({
          ...order,
          products: updatedProducts,
        })

        const allProductsHaveZeroQuantity = updatedProducts?.every(
          product => product.quantity === 0
        )

        setAllQty(allProductsHaveZeroQuantity)
        setSelectedProducts([])
        setSelectedPaymentTerm(null)
        setSelectedOrderReason(null)
        setSelectedPlant(null)
        setPlannedDeliveryDate(null)
        setHasOrderStatusUpdated(false)
        fetchOrder()
        fetchConfirmOrder()
      } else {
        setToastInfo({
          message: "Something went wrong",
          showToast: true,
          role: "error",
        })
      }
    } catch (error) {
      setToastInfo({
        message: error.message,
        showToast: true,
        role: "error",
      })
    } finally {
      setIsCreatingOrder(false)
    }
  }

  const handleDeleteOrder = async id => {
    try {
      let res = await deleteConfirmOrder({ id })
      if (res.status) {
        setToastInfo({
          message: "Order deleted successfully.",
          showToast: true,
          role: "success",
        })
        setDeleteModal({ open: false, id: null })
        setHasOrderStatusUpdated(false)

        fetchOrder()
        fetchConfirmOrder()
      } else {
        setToastInfo({
          message: "Something went wrong",
          showToast: true,
          role: "error",
        })
        setDeleteModal({ open: false, id: null })
      }
    } catch (e) {
      setToastInfo({
        message: "Something went wrong",
        showToast: true,
        role: "error",
      })
      setDeleteModal({ open: false, id: null })
    }
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false, message: "", data: null })
      handleCreateOrder()
    } else {
      setShowCommonDialog({ isShow: false, message: "", data: null })
    }
  }

  const handleInputChange = async (value, type) => {
    if (type === "plant") {
      try {
        let res = await getPlantsDropdown({ searchKey: value })
        if (res.status) {
          setPlantOptions(
            res?.data?.data?.map(i => ({
              label: `${i.description || ""} (${i.plantId})`,
              value: i.plantId,
            }))
          )
        }
      } catch (error) {
        console.error(error)
      }
    }
    if (type === "payment") {
      try {
        let res = await getPaymentTermsDropdown({ searchKey: value })
        if (res.status) {
          setPaymentTermOptions(
            res?.data?.data?.map(i => ({
              label: `${i.description || ""} (${i.paymentId})`,
              value: i.paymentId,
            }))
          )
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  const getApprovePermission = (data, id, status) => {
    try {
      if (data.isUploadedByEmployee) {
        return (
          data.employeeId !== id &&
          checkPermission() &&
          (status === "pending" || status === "processing")
        )
      } else {
        return (
          checkPermissionOrder() &&
          (status === "pending" || status === "processing")
        )
      }
    } catch (error) {
      return false
    }
  }

  const checkPermission = () => {
    const permissionsStr = localStorage.getItem("permissions")
    const permissions = JSON.parse(permissionsStr)
    const permission = permissions.find(
      p => p.permission_name == "bulk_upload_orders"
    )
    if (!permission) return false
    else return permission["approve_permission"] == 1
  }

  const checkPermissionOrder = () => {
    const permissionsStr = localStorage.getItem("permissions")
    const permissions = JSON.parse(permissionsStr)
    const permission = permissions.find(p => p.permission_name == "orders")
    if (!permission) return false
    else return permission["approve_permission"] == 1
  }

  const handleAddOrUpdateTrackingDetails = async (orderId, trackingURL) => {
    try {
      let res = await addOrUpdateTrackingDetails({
        trackingDetails: {
          orderId,
          trackingDetails: trackingURL,
        },
      })
      if (res.status) {
        setToastInfo({
          message: res.message,
          showToast: true,
          role: "success",
        })
        fetchTrackingDetails()
      }
    } catch (e) {
      setToastInfo({
        message: "Something went wrong",
        showToast: true,
        role: "error",
      })
    }
  }

  const getOrderStatusClasses = orderStatus => {
    if (orderStatus === "pending" || orderStatus === "processing") {
      return "bg-warning rounded-pill text-white px-3"
    } else if (orderStatus === "cancelled" || orderStatus === "rejected") {
      return "bg-danger rounded-pill text-white px-3"
    } else {
      return "bg-green rounded-pill text-white px-3"
    }
  }

  useEffect(() => {
    if (confirmOrders) {
      const initialProductOpen = confirmOrders?.reduce(
        (acc, _, index) => ({
          ...acc,
          [index]: index.toString(),
        }),
        {}
      )
      setProductOpen(initialProductOpen)
    }
  }, [confirmOrders])

  const fetchOrderReason = async () => {
    try {
      let res = await getAllRegions({dropdownName:'order_reasons'})
      if (res.status) {
        setOrderReasonOptions(
          res?.data?.regions[0]?.dropdownValues?.map(i => ({
            label: `${i.displayName} (${i.dropdownValue})`,
            value: i.dropdownValue,
          }))
        )
      } else {
        setOrderReasonOptions([])
      }
    } catch (error) {
      setOrderReasonOptions([])
      console.error(error)
    }
  }

  return (
    <>
      {(isCreatingOrder || isChangeStatus) && <FullPageLoader />}
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box d-flex gap-3 justify-content-between align-items-center">
            <h4 className="mb-sm-0 font-size-18">View Orders</h4>
            <div>
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={handleCancel}
              >
                Back
              </button>
            </div>
          </div>
          {order && (
            <Card className="mb-3">
              <CardBody>
                <Row>
                  <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                    <div className="mb-3">
                      <Label htmlFor="dealerType" className="label-styling">
                        Order Request ID
                      </Label>
                      <p>{order.orderCode}</p>
                    </div>
                  </Col>

                  <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                    <div className="mb-3">
                      <Label htmlFor="dealerType" className="label-styling">
                        Date
                      </Label>
                      <p>{formatDateTime(order.orderDate)}</p>
                    </div>
                  </Col>

                  <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                    <div className="mb-3">
                      <Label htmlFor="dealerType" className="label-styling">
                        Total Amount
                      </Label>
                      <p>{formatNumberWithCommas(order.totalAmount)}</p>
                    </div>
                  </Col>

                  <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                    <div className="mb-3">
                      <Label htmlFor="dealerType" className="label-styling">
                        PO Number
                      </Label>
                      <p>{order.poNumber || order.orderCode}</p>
                    </div>
                  </Col>

                  <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                    <div className="mb-3">
                      <Label htmlFor="shipToParty" className="label-styling">
                        Ship to Party
                      </Label>
                      <p>{order?.shipToParty || '-'}</p>
                    </div>
                  </Col>

                  <Col xs="12" md="2">
                    <div className="mb-3">
                      <Label htmlFor="dealerType" className="label-styling">
                        Order Status
                      </Label>
                      <p
                        className={`fw-bold py-1 status-pill text-capitalize ${getOrderStatusClasses(
                          order.orderStatus
                        )}`}
                      >
                        {order.orderStatus}
                      </p>
                    </div>
                  </Col>
                </Row>
                {!allQty && (
                  <>
                    <Row>
                      <Col md={12}>
                        <Accordion flush open={open} toggle={toggle}>
                          <AccordionItem>
                            <AccordionHeader
                              targetId="1"
                              style={{
                                borderBottom: "1px solid #adb5bd",
                                backgroundColor: "white",
                              }}
                            >
                              <h5
                                style={{ fontSize: "1rem", color: "#73778c" }}
                              >
                                Product Details
                              </h5>
                            </AccordionHeader>
                            <AccordionBody accordionId="1">
                              <div className="table-responsive">
                                <table
                                  style={{
                                    backgroundColor: "white",
                                    width: "100%",
                                  }}
                                >
                                  <thead
                                    style={{
                                      backgroundColor: "#f8f8fb",
                                      color: "#495057",
                                    }}
                                  >
                                    <tr>
                                      {getApprovePermission(
                                        order,
                                        user?.id,
                                        order?.orderStatus
                                      ) && (
                                        <>
                                          {showCheckboxes && (
                                            <th
                                              style={{ padding: "1rem 10px" }}
                                            >
                                              <div className="form-check">
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  style={{
                                                    border: "1px solid #B6BBC4",
                                                    transform: "scale(1.1)",
                                                  }}
                                                  id="selectAll"
                                                  checked={
                                                    selectedProducts?.length ===
                                                    order?.products?.filter(
                                                      i =>
                                                        i.remainingQuantity !==
                                                        0
                                                    ).length
                                                  }
                                                  onChange={handleSelectAll}
                                                />
                                              </div>
                                            </th>
                                          )}
                                        </>
                                      )}
                                      <th style={{ padding: "1rem 10px" }}>
                                        Product
                                      </th>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Product Name
                                      </th>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Product Code
                                      </th>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Requested Qty
                                      </th>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Remaining Qty
                                      </th>
                                      {getApprovePermission(
                                        order,
                                        user?.id,
                                        order?.orderStatus
                                      ) && (
                                        <th style={{ padding: "1rem 10px" }}>
                                          Qty
                                        </th>
                                      )}
                                      <th style={{ padding: "1rem 10px" }}>
                                        Total Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {order?.products?.map((product, index) => {
                                      const isSelected =
                                        selectedProducts?.includes(product?.id)

                                      return (
                                        <tr
                                          key={product.id}
                                          style={{
                                            backgroundColor: "white",
                                            borderBottom: "1px solid #ddd",
                                          }}
                                        >
                                          {showCheckboxes &&
                                            getApprovePermission(
                                              order,
                                              user?.id,
                                              order?.orderStatus
                                            ) && (
                                              <td
                                                style={{
                                                  padding: "1rem 0",
                                                  marginBottom: "15px",
                                                }}
                                              >
                                                {product?.quantity > 0 && (
                                                  <div
                                                    className="form-check"
                                                    style={{
                                                      marginLeft: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      disabled={
                                                        product.remainingQuantity ===
                                                        0
                                                      }
                                                      className="form-check-input"
                                                      id={`productCheckbox_${product.id}`}
                                                      checked={isSelected}
                                                      style={{
                                                        border:
                                                          "1px solid #B6BBC4",
                                                        transform: "scale(1.1)",
                                                      }}
                                                      onChange={() =>
                                                        handleCheckboxChange(
                                                          product.id
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              </td>
                                            )}
                                          <td
                                            style={{
                                              padding: "1rem 0",
                                              marginBottom: "15px",
                                            }}
                                          >
                                            <div
                                              className={
                                                product?.product
                                                  ?.productImages[0]?.image
                                                  ?.paths?.original &&
                                                !hasError[index]
                                                  ? "td-product-img"
                                                  : "td-no-product-img"
                                              }
                                            >
                                              {product?.product
                                                ?.productImages[0]?.image?.paths
                                                ?.original &&
                                              !hasError[index] ? (
                                                <img
                                                  src={
                                                    process.env
                                                      .REACT_APP_IMAGE_URL +
                                                    product?.product
                                                      ?.productImages[0]?.image
                                                      ?.paths?.original
                                                  }
                                                  alt=""
                                                  style={{
                                                    cursor: "pointer",
                                                    width: "100%",
                                                    height: "4.5rem",
                                                  }}
                                                  onError={e => {
                                                    e.target.onerror = null // Prevents infinite looping if default image also fails to load
                                                    e.target.src =
                                                      "/no-image.png"
                                                    e.target.style.width =
                                                      "2.5rem"
                                                    e.target.style.height =
                                                      "2.5rem"
                                                    setHasError(prevState => {
                                                      const newState = [
                                                        ...prevState,
                                                      ]
                                                      newState[index] = true
                                                      return newState
                                                    })
                                                  }}
                                                  className="img-fluid d-block"
                                                />
                                              ) : (
                                                <img
                                                  src={"/no-image.png"}
                                                  alt=""
                                                  className="img-fluid mx-auto d-block"
                                                  style={{
                                                    cursor: "pointer",
                                                    width: "2rem",
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              padding: "1rem 0",
                                              marginBottom: "15px",
                                            }}
                                          >
                                            <div style={{ marginLeft: "10px" }}>
                                              <h5 className="text-truncate font-size-14">
                                                {product?.product?.productName}
                                              </h5>
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              padding: "1rem 0",
                                              marginBottom: "15px",
                                            }}
                                          >
                                            <div style={{ marginLeft: "10px" }}>
                                              {product?.product?.sku}
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              padding: "1rem 0",
                                              marginBottom: "15px",
                                            }}
                                          >
                                            <div style={{ marginLeft: "10px" }}>
                                              {product?.quantity}
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              padding: "1rem 0",
                                              marginBottom: "15px",
                                            }}
                                          >
                                            <div style={{ marginLeft: "10px" }}>
                                              {product?.remainingQuantity}
                                            </div>
                                          </td>
                                          {getApprovePermission(
                                            order,
                                            user.id,
                                            order.orderStatus
                                          ) && (
                                            <td
                                              style={{
                                                padding: "1rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              <div style={{ width: "150px" }}>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                  className="input-group"
                                                >
                                                  <div className="input-group-prepend">
                                                    <button
                                                      type="button"
                                                      disabled={
                                                        product.remainingQuantity ===
                                                          0 ||
                                                        product.selectedQty ===
                                                          0 ||
                                                        product.selectedQty < 0
                                                      }
                                                      style={{
                                                        border: "none",
                                                        fontSize: "20px",
                                                      }}
                                                      className="btn"
                                                      onClick={() => {
                                                        const updatedProducts =
                                                          [...order.products]
                                                        const productIndex =
                                                          updatedProducts.findIndex(
                                                            p =>
                                                              p.id ===
                                                              product.id
                                                          )
                                                        if (
                                                          productIndex !== -1
                                                        ) {
                                                          updatedProducts[
                                                            productIndex
                                                          ].selectedQty =
                                                            updatedProducts[
                                                              productIndex
                                                            ].selectedQty === 0
                                                              ? 0
                                                              : updatedProducts[
                                                                  productIndex
                                                                ].selectedQty -
                                                                1
                                                        }
                                                        setOrder({
                                                          ...order,
                                                          products:
                                                            updatedProducts,
                                                        })
                                                      }}
                                                    >
                                                      -
                                                    </button>
                                                  </div>
                                                  <Input
                                                    style={{ height: "2.1rem" }}
                                                    maxLength={inputMax}
                                                    className="text-center"
                                                    name="demo_vertical"
                                                    type="text"
                                                    disabled={
                                                      product.remainingQuantity ===
                                                      0
                                                    }
                                                    value={
                                                      product.selectedQty || 0
                                                    }
                                                    onChange={e => {
                                                      if (
                                                        e.target.value.length >
                                                        16
                                                      ) {
                                                        setToastInfo({
                                                          message:
                                                            "Quantity Maximum limit exceeded",
                                                          showToast: true,
                                                          role: "error",
                                                        })
                                                        return
                                                      }
                                                      const value = parseInt(
                                                        e.target.value,
                                                        10
                                                      )
                                                      const selectedQty = isNaN(
                                                        value
                                                      )
                                                        ? ""
                                                        : value
                                                      const updatedProducts = [
                                                        ...order.products,
                                                      ]
                                                      const productIndex =
                                                        updatedProducts.findIndex(
                                                          p =>
                                                            p.id === product.id
                                                        )
                                                      if (productIndex !== -1) {
                                                        updatedProducts[
                                                          productIndex
                                                        ].selectedQty =
                                                          selectedQty < 0
                                                            ? 0
                                                            : selectedQty
                                                      }
                                                      setOrder({
                                                        ...order,
                                                        products:
                                                          updatedProducts,
                                                      })
                                                    }}
                                                  />
                                                  <div className="input-group-append">
                                                    <button
                                                      type="button"
                                                      className="btn"
                                                      style={{
                                                        border: "none",
                                                        fontSize: "20px",
                                                      }}
                                                      disabled={
                                                        product.remainingQuantity ===
                                                        0
                                                      }
                                                      onClick={() => {
                                                        const updatedProducts =
                                                          [...order.products]
                                                        const productIndex =
                                                          updatedProducts.findIndex(
                                                            p =>
                                                              p.id ===
                                                              product.id
                                                          )
                                                        if (
                                                          productIndex !== -1
                                                        ) {
                                                          updatedProducts[
                                                            productIndex
                                                          ].selectedQty =
                                                            Number(
                                                              updatedProducts[
                                                                productIndex
                                                              ].selectedQty
                                                            ) || 0
                                                          updatedProducts[
                                                            productIndex
                                                          ].selectedQty += 1
                                                        }
                                                        setOrder({
                                                          ...order,
                                                          products:
                                                            updatedProducts,
                                                        })
                                                      }}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          )}
                                          <td
                                            style={{
                                              padding: "1rem 0",
                                              marginBottom: "15px",
                                            }}
                                          >
                                            <div style={{ marginLeft: "10px" }}>
                                              {formatNumberWithCommas(
                                                product.price * product.quantity
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </AccordionBody>
                          </AccordionItem>
                        </Accordion>
                      </Col>
                    </Row>
                  </>
                )}
                <div className="d-flex gap-3">
                  {(order.orderStatus === "rejected" ||
                    order.orderStatus === "cancelled") &&
                    order?.remarks && (
                      <div className="mb-3 d-flex gap-1">
                        <Label
                          className="form-label"
                          style={{ fontWeight: 600 }}
                        >
                          Remarks:
                        </Label>
                        <p data-tooltip-id="remarks-tooltip">
                          {order?.remarks?.length > 50
                            ? `${order.remarks?.substring(0, 50)}...`
                            : order.remarks || "NA"}
                        </p>
                        <Tooltip
                          style={{ maxWidth: "500px", marginLeft: "1rem" }}
                          id={`remarks-tooltip`}
                          place="top"
                          content={order?.remarks}
                        />
                      </div>
                    )}
                </div>

                {!allQty && (
                  <>
                    {(order.orderStatus === "pending" ||
                      order.orderStatus === "processing") && (
                      <>
                        <Row className="mb-3 mt-4">
                          <Col xs="12" md="3">
                            <Label
                              className="form-label required"
                              style={{ fontWeight: 600 }}
                            >
                              Plant
                            </Label>
                            <Select
                              options={plantOptions}
                              value={selectedPlant}
                              menuPosition="fixed"
                              onChange={selectedOption =>
                                setSelectedPlant(selectedOption)
                              }
                              styles={{
                                menu: provided => ({
                                  ...provided,
                                }),
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                              }}
                              isDisabled={selectedProducts.length === 0}
                              onInputChange={e => {
                                handleInputChange(e, "plant")
                              }}
                            />
                          </Col>
                          <Col xs="12" md="3">
                            <Label
                              className="form-label required"
                              style={{ fontWeight: 600 }}
                            >
                              Payment Terms
                            </Label>
                            <Select
                              options={paymentTermOptions}
                              value={selectedPaymentTerm}
                              menuPosition="fixed"
                              onChange={selectedOption =>
                                setSelectedPaymentTerm(selectedOption)
                              }
                              isDisabled={selectedProducts.length === 0}
                              styles={{
                                menu: provided => ({
                                  ...provided,
                                }),
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                              }}
                              onInputChange={e => {
                                handleInputChange(e, "payment")
                              }}
                            />
                          </Col>
                          <Col xs="12" md="3">
                            <Label
                              fclassName="form-label"
                              style={{ fontWeight: 600 }}
                            >
                              Planned Delivery Date
                            </Label>
                            <Input
                              type="date"
                              id="plannedDeliveryDate"
                              value={plannedDeliveryDate || ""}
                              onChange={e =>
                                setPlannedDeliveryDate(e.target.value)
                              }
                              disabled={selectedProducts.length === 0}
                              min={new Date().toISOString().split("T")[0]}
                            />
                          </Col>
                          <Col xs="12" md="3">
                            <Label
                              className="form-label required"
                              style={{ fontWeight: 600 }}
                            >
                              Order Reason
                            </Label>
                            <Select
                              options={orderReasonOptions}
                              value={selectedOrderReason}
                              menuPosition="fixed"
                              onChange={selectedOption =>
                                setSelectedOrderReason(selectedOption)
                              }
                              isDisabled={selectedProducts.length === 0}
                              styles={{
                                menu: provided => ({
                                  ...provided,
                                }),
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                              }}
                            />
                          </Col>
                        </Row>
                        {selectedProducts.length > 0 && (
                          <div
                            className="d-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div>
                              <button
                                className="btn btn-success me-4"
                                type="button"
                                onClick={() => {
                                  setShowCommonDialog({
                                    isShow: true,
                                    message:
                                      "Are you sure you want to create order?",
                                    data: null,
                                  })
                                }}
                                disabled={
                                  selectedProducts.length === 0 ||
                                  !selectedPlant ||
                                  !selectedPaymentTerm ||
                                  !selectedOrderReason
                                }
                              >
                                {isCreatingOrder ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Please wait...
                                  </>
                                ) : (
                                  "+ Create Order"
                                )}
                              </button>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </CardBody>
            </Card>
          )}
          {confirmOrders &&
            confirmOrders?.map((order, index) => (
              <Card key={order.id} className="mb-3">
                <CardBody>
                  <Row>
                    <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                      <div className="mb-3">
                        <Label htmlFor="dealerType" className="label-styling">
                          Order ID
                        </Label>
                        <p>{order.orderCode}</p>
                      </div>
                    </Col>

                    <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                      <div className="mb-3">
                        <Label htmlFor="dealerType" className="label-styling">
                          SAP Order ID
                        </Label>
                        <p>{order?.sapOrderId || '-'}</p>
                      </div>
                    </Col>

                    <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                      <div className="mb-3">
                        <Label htmlFor="dealerType" className="label-styling">
                          Date
                        </Label>
                        <p>{formatDateTime(order.orderDate)}</p>
                      </div>
                    </Col>

                    <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                      <div className="mb-3">
                        <Label htmlFor="dealerType" className="label-styling">
                          Total Amount
                        </Label>
                        <p>{formatNumberWithCommas(order.totalAmount)}</p>
                      </div>
                    </Col>
                    <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                      <div className="mb-3">
                        <Label htmlFor="dealerType" className="label-styling">
                          Plant
                        </Label>
                        <p data-tooltip-id={`plant-tooltip${order.id}`}>
                          {order?.plantDescription?.length > 20
                            ? `${order.plantDescription?.substring(0, 20)}...`
                            : order.plantDescription || "NA"}
                        </p>
                        <Tooltip
                          style={{ maxWidth: "200px", marginLeft: "1rem" }}
                          id={`plant-tooltip${order.id}`}
                          place="top"
                          content={order?.plantDescription}
                        />
                      </div>
                    </Col>
                    <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                      <div className="mb-3">
                        <Label htmlFor="dealerType" className="label-styling">
                          Payment Terms
                        </Label>
                        <p data-tooltip-id={`payment-tooltip${order.id}`}>
                          {order?.paymentTermsDescription?.length > 20
                            ? `${order.paymentTermsDescription?.substring(
                                0,
                                20
                              )}...`
                            : order.paymentTermsDescription || "NA"}
                        </p>
                        <Tooltip
                          style={{ maxWidth: "200px", marginLeft: "1rem" }}
                          id={`payment-tooltip${order.id}`}
                          place="top"
                          content={order?.paymentTermsDescription}
                        />
                      </div>
                    </Col>

                    <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                      <div className="mb-3">
                        <Label htmlFor="dealerType" className="label-styling">
                          Order Reason
                        </Label>
                        <p>
                          {(() => {
                            const found = orderReasonOptions?.find(opt => opt.value === order?.orderReason);
                            return found ? `${found.label}` : '-';
                          })()}
                        </p>
                      </div>
                    </Col>

                    <Col
                      xs="12"
                      md={!showDropdown[order?.id] ? "3" : "2"}
                      style={{ marginRight: "30px" }}
                    >
                      <div className="mb-3">
                        <Label htmlFor="dealerType" className="label-styling">
                          Order Status
                        </Label>
                        <div className="d-flex gap-2">
                          <p className="status-pill py-1 bg-green rounded-pill text-white">
                            {startCase(order.orderStatus)}
                          </p>
                          {order.orderStatus !== "shipped" &&
                            !showDropdown[order.id] && (
                              <div className="mt-1">
                                <a
                                  href="#"
                                  onClick={e => {
                                    e.preventDefault()
                                    setShowDropdown(prevState => ({
                                      ...prevState,
                                      [order.id]: true,
                                    }))
                                  }}
                                >
                                  Change Status
                                </a>
                              </div>
                            )}
                        </div>
                      </div>
                    </Col>
                    <Col xs="12" md="2">
                      {showDropdown[order.id] && (
                        <div className="d-flex mt-2">
                          <Input
                            name="depot"
                            type="select"
                            style={{
                              width: "190px",
                              display: "inline",
                              marginBottom: "1rem",
                            }}
                            onChange={e => {
                              setStatus(prevStatus => ({
                                ...prevStatus,
                                [order.id]: e.target.value,
                              }))
                            }}
                            defaultValue={"shipped"}
                          >
                            <option value="" disabled>
                              Change Order Status
                            </option>
                            <option value="shipped">Shipped</option>
                          </Input>
                          <div>
                            <button
                              className="btn btn-success ms-3"
                              type="button"
                              onClick={() => handleUpdateStatus(order.id)}
                            >
                              {isChangeStatus ? (
                                <>
                                  {/* <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                      ></span> */}
                                  Saving...
                                </>
                              ) : (
                                "Save"
                              )}
                            </button>
                          </div>
                          <div>
                            <button
                              className="btn btn-outline-secondary ms-2"
                              type="button"
                              onClick={() =>
                                setShowDropdown(prevState => ({
                                  ...prevState,
                                  [order.id]: false,
                                }))
                              }
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="mb-2">
                        <Accordion
                          flush
                          open={productOpen[index]}
                          toggle={accordionId =>
                            toggleProduct(index, accordionId)
                          }
                        >
                          <AccordionItem>
                            <AccordionHeader
                              targetId={index.toString()}
                              style={{
                                borderBottom: "1px solid #adb5bd",
                                backgroundColor: "white",
                              }}
                            >
                              <h5
                                style={{ fontSize: "1rem", color: "#73778c" }}
                              >
                                Product Details
                              </h5>
                            </AccordionHeader>
                            <AccordionBody accordionId={index.toString()}>
                              <div className="table-responsive">
                                <table
                                  className=""
                                  style={{
                                    backgroundColor: "white",
                                    width: "100%",
                                  }}
                                >
                                  <thead
                                    style={{
                                      backgroundColor: "#f8f8fb",
                                      color: "#495057",
                                    }}
                                  >
                                    <tr>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Product
                                      </th>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Product Name
                                      </th>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Product Code
                                      </th>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Qty
                                      </th>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Total Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {order?.orderedProducts?.map(
                                      (product, index) => {
                                        return (
                                          <tr
                                            key={product.id}
                                            style={{
                                              backgroundColor: "white",
                                              borderBottom: "1px solid #ddd",
                                            }}
                                          >
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                                paddingLeft: "0.6rem",
                                              }}
                                            >
                                              <div
                                                className={
                                                  product?.product
                                                    ?.productImages[0]?.image
                                                    ?.paths?.original &&
                                                  !hasConfirmError[index]
                                                    ? "td-product-img"
                                                    : "td-no-product-img"
                                                }
                                              >
                                                {product?.product
                                                  ?.productImages[0]?.image
                                                  ?.paths?.original &&
                                                !hasConfirmError[index] ? (
                                                  <img
                                                    src={
                                                      process.env
                                                        .REACT_APP_IMAGE_URL +
                                                      product?.product
                                                        ?.productImages[0]
                                                        ?.image?.paths?.original
                                                    }
                                                    alt=""
                                                    style={{
                                                      cursor: "pointer",
                                                      width: "100%",
                                                      height: "4.5rem",
                                                    }}
                                                    onError={e => {
                                                      e.target.onerror = null // Prevents infinite looping if default image also fails to load
                                                      e.target.src =
                                                        "/no-image.png"
                                                      e.target.style.width =
                                                        "2.5rem"
                                                      e.target.style.height =
                                                        "2.5rem"
                                                      setHasConfirmError(
                                                        prevState => {
                                                          const newState = [
                                                            ...prevState,
                                                          ]
                                                          newState[index] = true
                                                          return newState
                                                        }
                                                      )
                                                    }}
                                                    className="img-fluid d-block"
                                                  />
                                                ) : (
                                                  <img
                                                    src={"/no-image.png"}
                                                    alt=""
                                                    className="img-fluid mx-auto d-block"
                                                    style={{
                                                      cursor: "pointer",
                                                      width: "2rem",
                                                    }}
                                                  />
                                                )}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              <div
                                                style={{ marginLeft: "10px" }}
                                              >
                                                <h5 className="text-truncate font-size-14">
                                                  {
                                                    product?.product
                                                      ?.productName
                                                  }
                                                </h5>
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              <div
                                                style={{ marginLeft: "10px" }}
                                              >
                                                {product?.product?.sku}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              <div
                                                style={{ marginLeft: "10px" }}
                                              >
                                                {product.quantity}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              <div
                                                style={{ marginLeft: "10px" }}
                                              >
                                                {" "}
                                                {formatNumberWithCommas(
                                                  product.price *
                                                    product.quantity
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </AccordionBody>
                          </AccordionItem>
                        </Accordion>
                      </div>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col
                      md={6}
                      className="d-flex justify-content-start align-items-center"
                    >
                      <div
                        style={{ flexDirection: "column" }}
                        className="d-flex gap-2"
                      >
                        <Label htmlFor="dealerType" className="label-styling">
                          Tracking Details
                        </Label>
                        <div className="d-flex gap-2 align-items-center">
                          <Input
                            type="textarea"
                            maxLength={inputMax}
                            id="tracking"
                            style={{ width: "250px" }}
                            className="mr-3 p-2"
                            placeholder="Enter tracking Details"
                            value={trackingUrl[order.id] || ""}
                            onChange={e => {
                              setTrackingUrl({
                                ...trackingUrl,
                                [order.id]: e.target.value,
                              })
                            }}
                          />

                          <button
                            className="btn btn-success"
                            type="button"
                            disabled={!trackingUrl[order.id]}
                            onClick={() => {
                              handleAddOrUpdateTrackingDetails(
                                order.id,
                                trackingUrl[order.id]
                              )
                            }}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <AdminShipmentDetail
                      orderCode={order?.orderCode}
                      setToastInfo={setToastInfo}
                    />
                  </Row>
                </CardBody>
              </Card>
            ))}
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
      <DeleteModal
        show={deleteModal.open}
        onDeleteClick={() => {
          handleDeleteOrder(deleteModal.id)
        }}
        onCloseClick={() => setDeleteModal({ open: false, id: null })}
      />
      {showCommonDialog && (
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message}
          data={showCommonDialog.data}
          postitiveBtn={"Submit"}
          negativeBtn={"Close"}
          onCloseFn={dialogAction}
        ></CommonDialog>
      )}
    </>
  )
}

export default ViewOrder
